// Partner Application Form JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Cache partner fee form elements at top level
  const partnerForm = document.getElementById('partner-application-form');
  let partnerFeeElements = null;
  
  if (partnerForm) {
    const submitBtn = partnerForm.querySelector('.partner-application-submit-btn');
    const loaderBtn = partnerForm.querySelector('.partner-application-loader');
    const formBtnContainer = partnerForm.querySelector('.partner-application-form-btn');
    
    if (submitBtn && loaderBtn && formBtnContainer) {
      partnerFeeElements = { submitBtn, loaderBtn, formBtnContainer, form: partnerForm };
      
      // Ensure initial state: loader visible, submit button hidden
      submitBtn.classList.add('display-none');
      formBtnContainer.classList.add('no-click');
      loaderBtn.classList.remove('display-none');
    }
  }
  
  // Show page loader on initial load
  showPartnerPageLoader();
  
  // Run initial checks and hide loader when complete
  Promise.all([
    checkPartnerFeeInCart(partnerFeeElements)
  ]).finally(() => {
    hidePartnerPageLoader();
  });
  
  // Listen for cart update events to re-check partner fee status
  document.querySelector('cart-form')?.addEventListener('cart-updated', async function() {
    // Show page loader first
    showPartnerPageLoader();
    await Promise.all([
      checkPartnerFeeInCart(partnerFeeElements)
    ]);
    // Hide page loader after all checks complete
    hidePartnerPageLoader();
  });
  
  // Handle main partner application form
  if (!partnerForm) return;
  
  partnerForm.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Use cached elements if available, otherwise query
    const submitBtn = partnerFeeElements?.submitBtn || partnerForm.querySelector(".partner-application-submit-btn");
    const loaderBtn = partnerFeeElements?.loaderBtn || partnerForm.querySelector(".partner-application-loader");
    const formBtnContainer = partnerFeeElements?.formBtnContainer || partnerForm.querySelector(".partner-application-form-btn");

    // Show loading state
    if (submitBtn) submitBtn.classList.add("display-none");
    if (formBtnContainer) formBtnContainer.classList.add("no-click");
    if (loaderBtn) loaderBtn.classList.remove("display-none");

    // Get hidden field values first
    const inputs = partnerForm.querySelectorAll('input[type="hidden"]');
    const partnerFeeVariantId = Array.from(inputs).find(
      (input) => input.getAttribute("name") === "partner-fee-variant-id"
    )?.value;

    if (!partnerFeeVariantId) {
      console.error("Partner fee variant ID is missing");
      return;
    }

    // Real-time validation: Check cart at submission time (defense in depth)
    try {
      const cartData = window.JPCartService
        ? await window.JPCartService.getCart({ force: true })
        : await (await fetch("/cart.js")).json();

      // Check if partner fee already exists in cart
      for (const item of cartData.items) {
        if (
          item.variant_id.toString() === partnerFeeVariantId.toString() &&
          item.properties &&
          item.properties._partner_fee === "true"
        ) {
          console.log("partner fee is already in cart - submission prevented");
          // Update button state to reflect current cart state (use cached element)
          if (submitBtn) {
            const whiteTickIconElement = document.querySelector(
              ".partner-white-tick-icon"
            );
            const whiteTickIcon = whiteTickIconElement
              ? whiteTickIconElement.innerHTML
              : "";
            const addedText =
              KROWN?.settings?.locales?.partner_application_form?.added ||
              "Added";
            submitBtn.innerHTML = addedText + " " + whiteTickIcon;
            submitBtn.disabled = true;
            submitBtn.classList.add("btn--disabled");
          }
          return;
        }
      }
    } catch (error) {
      console.error("Error checking cart during submission:", error);
      // On error, still allow submission (fail open)
    }
    const partnerFeeSellingPlanId = Array.from(inputs).find(
      (input) => input.getAttribute("name") === "partner-fee-selling-plan-id"
    )?.value;
    const partnerFeeDiscountValue =
      Array.from(inputs).find(
        (input) => input.getAttribute("name") === "partner-fee-discount-value"
      )?.value || "";
    // Welcome Pack 1
    const welcomePackVariantId1 = Array.from(inputs).find(
      (input) => input.getAttribute("name") === "welcome-pack-variant-id-1"
    )?.value;
    const welcomePackDiscountValue1 =
      Array.from(inputs).find(
        (input) => input.getAttribute("name") === "welcome-pack-discount-value-1"
      )?.value || "";
    // Welcome Pack 2
    const welcomePackVariantId2 = Array.from(inputs).find(
      (input) => input.getAttribute("name") === "welcome-pack-variant-id-2"
    )?.value;
    const welcomePackDiscountValue2 =
      Array.from(inputs).find(
        (input) => input.getAttribute("name") === "welcome-pack-discount-value-2"
      )?.value || "";
    // Welcome Pack 3
    const welcomePackVariantId3 = Array.from(inputs).find(
      (input) => input.getAttribute("name") === "welcome-pack-variant-id-3"
    )?.value;
    const welcomePackDiscountValue3 =
      Array.from(inputs).find(
        (input) => input.getAttribute("name") === "welcome-pack-discount-value-3"
      )?.value || "";
    const congratulationsMessage =
      document.querySelector("#congratulations-message")?.value || "false";

    try {
      document.dispatchEvent(new Event("checkout-buttons-section:show-loader", { bubbles: true }));
      // Check for old partner fee items (without _partner_fee property) and remove them
      const cartData = window.JPCartService
        ? await window.JPCartService.getCart({ force: true })
        : await (await fetch("/cart.js")).json();

      const updates = {};
      let hasOldPartnerFee = false;

      // Find partner fee items with matching variant ID but without _partner_fee property
      for (const item of cartData.items) {
        if (item.variant_id.toString() === partnerFeeVariantId.toString()) {
          // Check if it doesn't have the _partner_fee property (old flow)
          if (!item.properties || item.properties._partner_fee !== "true") {
            updates[item.key] = 0;
            hasOldPartnerFee = true;
          }
        }
      }

      // Remove old partner fee items if found
      if (hasOldPartnerFee) {
        if (window.JPCartService) {
          await window.JPCartService.update({ updates }).catch((error) => {
            console.error("Error removing old partner fee:", error);
          });
        } else {
          await fetch(
            `${KROWN?.settings?.routes?.cart_update_url || "/cart/update"}.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ updates }),
            }
          ).catch((error) => {
            console.error("Error removing old partner fee:", error);
          });
        }
      }

      // Determine Payment Method
      const paymentMethod =
        window.cartAvailablePaymentMethods?.subscription?.includes("Online")
          ? "Online"
          : window.cartAvailablePaymentMethods?.subscription?.[0] || "Online";

      const isManualPayment =
        KROWN?.settings?.manualPaymentTypes?.includes(paymentMethod) || false;

      // Build cart items array
      const items = [];

      // Partner Fee Item (with selling plan)
      const partnerFeeItem = {
        id: partnerFeeVariantId,
        quantity: 1,
        selling_plan: isManualPayment ? null : partnerFeeSellingPlanId,
      };

      partnerFeeItem.properties = {
        _sellingplan: isManualPayment ? partnerFeeSellingPlanId : "",
        _discountvalue: partnerFeeDiscountValue,
        _partner_fee: "true",
      };

      items.push(partnerFeeItem);

      // Welcome Pack Items (one-time purchase, no selling plan)
      // Welcome Pack 1
      if (welcomePackVariantId1) {
        const welcomePackItem1 = {
          id: welcomePackVariantId1,
          quantity: 1,
        };

        welcomePackItem1.properties = {
          _discountvalue: welcomePackDiscountValue1,
          _partner_fee_bundle: partnerFeeVariantId,
          _partner_fee_welcome_pack: "true",
        };

        items.push(welcomePackItem1);
      }

      // Welcome Pack 2
      if (welcomePackVariantId2) {
        const welcomePackItem2 = {
          id: welcomePackVariantId2,
          quantity: 1,
        };

        welcomePackItem2.properties = {
          _discountvalue: welcomePackDiscountValue2,
          _partner_fee_bundle: partnerFeeVariantId,
          _partner_fee_welcome_pack: "true",
        };

        items.push(welcomePackItem2);
      }

      // Welcome Pack 3
      if (welcomePackVariantId3) {
        const welcomePackItem3 = {
          id: welcomePackVariantId3,
          quantity: 1,
        };

        welcomePackItem3.properties = {
          _discountvalue: welcomePackDiscountValue3,
          _partner_fee_bundle: partnerFeeVariantId,
          _partner_fee_welcome_pack: "true",
        };

        items.push(welcomePackItem3);
      }

      // Build form data with cart attributes
      const formData = {
        attributes: {
          _paymentMethod: paymentMethod,
          _newFlow: false,
          _availablePayments:
            window.cartAvailablePaymentMethods?.subscription || [],
        },
        items: items,
      };

      if (typeof window.applyVariantGlobalIdToCartItemsSync === 'function') {
        window.applyVariantGlobalIdToCartItemsSync(formData.items);
      }

      // Add partner fee product attribute if congratulations message is true
      if (congratulationsMessage === "true") {
        formData.attributes._partnerFeeProduct = partnerFeeVariantId;
      }

      // Add items to cart using Shopify AJAX API
      if (window.JPCartService) {
        try {
          await window.JPCartService.add(formData);
        } catch (error) {
          console.error("Error adding to cart:", error.body || error);
          throw new Error("Failed to add items to cart");
        }
      } else {
        const response = await fetch(
          `${KROWN?.settings?.routes?.cart_add_url || "/cart/add"}.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (!response.ok) {
          const error = await response.json();
          console.error("Error adding to cart:", error);
          throw new Error("Failed to add items to cart");
        }
      }

      // Refresh cart after adding
      await refreshCartForPartnerApplicationForm();

      // Update button to "Added" state
      if (submitBtn) {
        const whiteTickIconElement = document.querySelector(
          ".partner-white-tick-icon"
        );
        const whiteTickIcon = whiteTickIconElement
          ? whiteTickIconElement.innerHTML
          : "";
        const addedText =
          KROWN?.settings?.locales?.partner_application_form?.added || "Added";
        submitBtn.innerHTML = addedText + " " + whiteTickIcon;
        submitBtn.disabled = true;
        submitBtn.classList.add("btn--disabled");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      // Restore UI (but keep button state if successfully added)
      if (loaderBtn) loaderBtn.classList.add("display-none");
      if (submitBtn) submitBtn.classList.remove("display-none");
      if (formBtnContainer) formBtnContainer.classList.remove("no-click");
    }
  });
});

// Show partner page loader
function showPartnerPageLoader() {
  const pageLoader = document.getElementById('partner-page-loader');
  if (pageLoader) {
    pageLoader.classList.remove('hidden');
  }
}

// Hide partner page loader
function hidePartnerPageLoader() {
  const pageLoader = document.getElementById('partner-page-loader');
  if (pageLoader) {
    pageLoader.classList.add('hidden');
  }
}

// Check if partner fee is in cart on page load
async function checkPartnerFeeInCart(partnerFeeElements = null) {
  // Use cached elements if provided, otherwise query
  const form = partnerFeeElements?.form || document.getElementById('partner-application-form');
  if (!form) {
    return;
  }
  
  const submitBtn = partnerFeeElements?.submitBtn || form.querySelector('.partner-application-submit-btn');
  const loaderBtn = partnerFeeElements?.loaderBtn || form.querySelector('.partner-application-loader');
  const formBtnContainer = partnerFeeElements?.formBtnContainer || form.querySelector('.partner-application-form-btn');
  
  if (!submitBtn || !loaderBtn || !formBtnContainer) {
    return;
  }
  
  // Get partner fee variant ID from hidden field
  const partnerFeeVariantIdInput = form.querySelector('input[name="partner-fee-variant-id"]');
  if (!partnerFeeVariantIdInput || !partnerFeeVariantIdInput.value) {
    return;
  }
  
  const partnerFeeVariantId = partnerFeeVariantIdInput.value;
  
  // Show loader, hide submit button
  submitBtn.classList.add('display-none');
  formBtnContainer.classList.add('no-click');
  loaderBtn.classList.remove('display-none');
  
  try {
    // Fetch cart data
    const cartData = window.JPCartService
      ? await window.JPCartService.getCart({ force: true })
      : await (await fetch('/cart.js')).json();
    
    // Check if partner fee exists in cart
    let partnerFeeInCart = false;
    for (const item of cartData.items) {
      // Check by variant ID and property
      if (item.variant_id.toString() === partnerFeeVariantId.toString() && 
          item.properties && item.properties._partner_fee === 'true') {
        partnerFeeInCart = true;
        break;
      }
    }
    
    // Update button state based on cart check
    if (partnerFeeInCart) {
      // Partner fee is in cart - show "Added" and disable
      const whiteTickIconElement = document.querySelector('.partner-white-tick-icon');
      const whiteTickIcon = whiteTickIconElement ? whiteTickIconElement.innerHTML : '';
      const addedText = KROWN?.settings?.locales?.partner_application_form?.added || 'Added';
      submitBtn.innerHTML = addedText + ' ' + whiteTickIcon;
      submitBtn.disabled = true;
      submitBtn.classList.add('btn--disabled');
    } else {
      // Partner fee not in cart - show "Add to cart" normally
      submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to cart';
      submitBtn.disabled = false;
      submitBtn.classList.remove('btn--disabled');
    }
    
  } catch (error) {
    console.error('Error checking cart for partner fee:', error);
    // On error, default to "Add to cart" state
    submitBtn.textContent = submitBtn.getAttribute('data-original-text') || 'Add to cart';
    submitBtn.disabled = false;
    submitBtn.classList.remove('btn--disabled');
  } finally {
    // Hide loader, show submit button
    loaderBtn.classList.add('display-none');
    submitBtn.classList.remove('display-none');
    formBtnContainer.classList.remove('no-click');
  }
}

// Refresh cart function - exposed globally for use by other sections
async function refreshCartForPartner() {
  try {
    const response = await fetch('?section_id=helper-cart');
    const text = await response.text();
    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
    const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm')?.innerHTML;
    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal')?.innerHTML;

    const cartItems = document.getElementById('AjaxCartForm');
    if (cartItems && cartFormInnerHTML) {
      cartItems.innerHTML = cartFormInnerHTML;
      if (cartItems.ajaxifyCartItems) {
        cartItems.ajaxifyCartItems();
      }
    }

    document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
      const cartCount = cartItems?.querySelector('[data-cart-count]')?.textContent;
      if (cartCount) {
        elm.textContent = cartCount;
      }
    });

    document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
      const cartTotal = cartItems?.querySelector('[data-cart-total]')?.textContent;
      if (cartTotal) {
        elm.textContent = cartTotal;
      }
    });

    const cartSubtotal = document.getElementById('AjaxCartSubtotal');
    if (cartSubtotal && cartSubtotalInnerHTML) {
      cartSubtotal.innerHTML = cartSubtotalInnerHTML;
    }

    if (document.querySelector("[data-js-site-cart-sidebar]")) {
      document.querySelector("[data-js-site-cart-sidebar]").show();
    }

    if (document.querySelector('cart-recommendations')) {
      const cartRecommendations = document.querySelector('cart-recommendations');
      cartRecommendations.innerHTML = '';
      if (cartRecommendations.generateRecommendations) {
        cartRecommendations.generateRecommendations();
      }
    }
    // Add refreshCartPaymentMethods call
    if (typeof window.refreshCartPaymentMethods === 'function') {
      await window.refreshCartPaymentMethods();
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}

// Refresh cart function - exposed globally for use by other sections
async function refreshCartForPartnerApplicationForm() {
  try {
    const response = await fetch('?section_id=helper-cart');
    const text = await response.text();
    const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
    const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm')?.innerHTML;
    const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal')?.innerHTML;

    const cartItems = document.getElementById('AjaxCartForm');
    if (cartItems && cartFormInnerHTML) {
      cartItems.innerHTML = cartFormInnerHTML;
      if (cartItems.ajaxifyCartItems) {
        cartItems.ajaxifyCartItems();
      }
    }

    document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
      const cartCount = cartItems?.querySelector('[data-cart-count]')?.textContent;
      if (cartCount) {
        elm.textContent = cartCount;
      }
    });

    document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
      const cartTotal = cartItems?.querySelector('[data-cart-total]')?.textContent;
      if (cartTotal) {
        elm.textContent = cartTotal;
      }
    });

    const cartSubtotal = document.getElementById('AjaxCartSubtotal');
    if (cartSubtotal && cartSubtotalInnerHTML) {
      cartSubtotal.innerHTML = cartSubtotalInnerHTML;
    }

    if (document.querySelector('cart-recommendations')) {
      const cartRecommendations = document.querySelector('cart-recommendations');
      cartRecommendations.innerHTML = '';
      if (cartRecommendations.generateRecommendations) {
        cartRecommendations.generateRecommendations();
      }
    }
    // Add refreshCartPaymentMethods call
    if (typeof window.refreshCartPaymentMethods === 'function') {
      await window.refreshCartPaymentMethods();
    }
  } catch (error) {
    console.error('Error refreshing cart:', error);
  }
}


// ============================================================
// Shopify Theme Editor Integration
// Re-initialize JavaScript when sections are loaded/re-rendered
// ============================================================

function initPartnerApplicationSection() {
  // Re-attach cart-updated listener if not already attached
  const cartForm = document.querySelector('cart-form');
  if (cartForm && !cartForm.hasAttribute('data-design-mode-listener')) {
    cartForm.setAttribute('data-design-mode-listener', 'true');
    
    cartForm.addEventListener('cart-updated', async function() {
      // Show page loader first
      if (typeof showPartnerPageLoader === 'function') {
        showPartnerPageLoader();
      }
      
      await checkPartnerFeeInCart();
      
      // Hide page loader after check complete
      if (typeof hidePartnerPageLoader === 'function') {
        hidePartnerPageLoader();
      }
    });
  }
}

// Listen for Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  // Check if this is the partner application section
  if (event.target.querySelector('.partner-application-section')) {
    initPartnerApplicationSection();
  }
});

// Run full logic in Shopify design mode (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  function runDesignModeInit() {
    // Show page loader first (same as normal flow)
    if (typeof showPartnerPageLoader === 'function') {
      showPartnerPageLoader();
    }
    
    // Cache partner fee elements
    const partnerForm = document.getElementById('partner-application-form');
    let partnerFeeElements = null;
    
    if (partnerForm) {
      const submitBtn = partnerForm.querySelector('.partner-application-submit-btn');
      const loaderBtn = partnerForm.querySelector('.partner-application-loader');
      const formBtnContainer = partnerForm.querySelector('.partner-application-form-btn');
      
      if (submitBtn && loaderBtn && formBtnContainer) {
        partnerFeeElements = { submitBtn, loaderBtn, formBtnContainer, form: partnerForm };
        // Ensure initial state: loader visible, submit button hidden
        submitBtn.classList.add('display-none');
        formBtnContainer.classList.add('no-click');
        loaderBtn.classList.remove('display-none');
      }
    }
    
    // Run checks and hide loader when complete
    checkPartnerFeeInCart(partnerFeeElements).finally(() => {
      if (typeof hidePartnerPageLoader === 'function') {
        hidePartnerPageLoader();
      }
    });
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runDesignModeInit);
  } else {
    runDesignModeInit();
  }
}
